import {useTranslation} from "react-i18next";


const transl = (strName) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const {t} = useTranslation("search");
    return t(strName)
};
export default transl;